const CashInChannel = {
  Card: "card",
  ManualPaymaya: "manual-paymaya",
  ManualBankDeposit: "manual-bank-deposit",
  OnlineBanking: "online-banking",
  LocqRebate: "locq-rebate",
  IntroductoryPromo: "introductory-promo",
  WithholdingTaxRefund: "withholding-tax-refund",
  WithholdingTaxRefundSurf: "withholding-tax-refund-surf",
  SeaoilReciprocity: "seaoil-reciprocity",
  OTC: "otc",
  LocqpayDiscount: "locq-pay-discount",
  VIP: "vip-locqpay",
  ManualBankDepositSPI: "manual-bank-deposit-spi",
  Adjustment: "adjustment-spi",
};

export default CashInChannel;
